import { render, staticRenderFns } from "./Thead.vue?vue&type=template&id=0b83778e&scoped=true&"
import script from "./Thead.vue?vue&type=script&lang=js&"
export * from "./Thead.vue?vue&type=script&lang=js&"
import style0 from "./Thead.vue?vue&type=style&index=0&id=0b83778e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b83778e",
  null
  
)

export default component.exports